<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  $input = $('.block-search input')
    $input.attr('placeholder', 'Trouvez une solution')
    $input.on('blur', () => {
      setTimeout(collapse.bind(this), 100)
    })

    if ($(window).width() <= 768) {
      $(this.$el).on('click', () => {
        if ($(this.$el).hasClass('open')) collapse()
        else expand()
      })
    } else {
      $input.on('click', this.expand.bind(this))
    }

    // ???
    $(this.$el)
      .find('#edit-keys--2')
      .attr('placeholder', 'Trouvez une solution')
})

function expand() {
  this.$input.attr('placeholder', 'Formulez votre demande, question...')
  $(this.$el).addClass('open')
  this.$input.focus()
}

function collapse() {
  this.$input.attr('placeholder', 'Trouvez une solution')
  $(this.$el).removeClass('open')
}

</script>


<style lang="sass">

@import ../../common/styles/mixins
@import ../../common/styles/settings

.block-search
    position: relative
    transition: padding $speed-fast $authentic-motion, margin $speed-fast $authentic-motion

    +media("<=768px")
        min-width: 2rem
        min-height: 2rem
        box-sizing: border-box

    &.icon
        padding-left: 2.5rem
        &:before
           top: calc(50% - .75rem)
           left: .5rem
           +media("<=768px")
               top: 5px
               left: 15px

    input
        background: transparent
        border: 0!important
        background-image: none!important
        width: 9.5rem
        margin-right: 2.5rem
        font-family: 'Now Alt', sans-serif
        transition: width $speed-fast $authentic-motion
        +media("<=768px")
            position: fixed
            left: 0
            width: 100%
            background: $color-base
            top: 4rem
            height: 4rem
            padding: 0 2rem
            box-sizing: border-box
            display: none

    input[placeholder], [placeholder], *[placeholder]
        color: #fff!important

    input:focus
        outline-style: none

    #edit-actions
        display: none

    &.open
        +media(">768px")
            border: 1px solid white
            padding: 1rem 1rem 1rem 2.5rem
            margin-right: 1rem
            input
                width: 18rem

        +media("<=768px")
            input
                display: block


.pager
    &__items
        padding: $baseline 0 $baseline*2
        text-align: center

    &__item
        display: inline-block
        padding: $baseline
        line-height: .5
        transition: color $speed-fast $authentic-motion
        width: $baseline*.25

        a
            color: inherit
            text-decoration: none
            font-weight: initial

        &:hover
            color: $color-side
        &.is-active
            color: white
            background: $color-accent
        &--previous,
        &--next
            width: auto
            color: $color-side
            text-transform: uppercase

        &.pager__item--first,
        &.pager__item--last
            display: none
</style>
